import { Checkbox, Col, Form, Input, InputNumber, Row, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface Prop {
  productName?: string;
  sku?: string;
  eanUpc?: string;
  quantity?: any;
  haveCheck?: any;
  _getId?: any;
  id?: number;
  onchange1?: (value: any) => void;
  enableQuantity?: Boolean;
}
const { Text } = Typography;

const Product = ({
  productName,
  sku,
  eanUpc,
  quantity,
  haveCheck,
  _getId,
  id,
  onchange1,
  enableQuantity
}: Prop) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      productName: productName,
      sku: sku,
      eanUpc: eanUpc,
      quantity: quantity
    });
    setQuantityOld(quantity);
  }, [id]);

  const [quantityOld, setQuantityOld] = useState(0);
  const location = useLocation();

  return (
    <div className="wrapReturnPro">
      <div className="proRe">
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            productName: '',
            sku: '',
            eanUpc: '',
            quantity: 0
          }}
        >
          {haveCheck ? <Checkbox value={id} /> : null}

          <Row className="rowDeliver">
            <Col span={10}>
              <Form.Item label="Product Name" name="productName">
                <Input className="border-input" disabled />
              </Form.Item>
            </Col>

            <Col span={4}>
              <Form.Item label="SKU" name="sku">
                <Input className="border-input" disabled />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="EAN/UPC" name="eanUpc">
                <Input className="border-input" disabled />
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item
                label="Quantity"
                name="quantity"
                rules={[
                  {
                    type: 'number',
                    min: 1,
                    message: `Must be greater than 0`
                  }
                ]}
              >
                <InputNumber
                  disabled={
                    location.pathname === '/admin/seller/shipping/create-return' || enableQuantity ? false : true
                  }
                  id="inputQuantity"
                  className="border-input"
                  placeholder={String(quantityOld ?? 0)}
                  max={quantityOld ?? 0}
                  min={0}
                  onChange={(e: any) => {
                    onchange1 && onchange1(e);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      {/* ))} */}
    </div>
  );
};

export default Product;
